import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { scrollToTop } from '../util/scrollUtils';

/**
 * ScrollToTop component that automatically scrolls to the top of the page
 * whenever the route changes. This should be placed inside the Router component.
 */
export function ScrollToTop() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        // Use cross-platform scroll utility for iOS compatibility
        scrollToTop('instant');
    }, [pathname, search]);

    return null;
}

